import React from "react";
import ActionDialog from "../../ActionDialog";
import { Divider, makeStyles, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import SectionTitle from "./SectionTitle";
import HelpSharpIcon from "@material-ui/icons/HelpSharp";
import EventAvailableSharpIcon from "@material-ui/icons/EventAvailableSharp";
import DragIndicatorSharpIcon from "@material-ui/icons/DragIndicatorSharp";
import AssessmentIcon from "@material-ui/icons/Assessment";
import TableChartIcon from "@material-ui/icons/TableChart";
import TipBox from "../../TipBox";

const useStyles = makeStyles((theme) => ({
  divider: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
}));

const HelpReportAgentsFinancial = ({ open, setOpen, enableBonusManager, enableBonusManagerOneTime }) => {
  const classes = useStyles();

  return (
    <ActionDialog
      open={open}
      title="app.report.manager.tittle"
      onClose={() => setOpen(false)}
      maxWidth="md"
      enableConfirmButton={false}
    >
      {/* descrição */}
      <Typography
        gutterBottom
        className={classes.divider}
      >
        <FormattedMessage id="app.report.manager.description" />
      </Typography>

      {/* como usar */}
      <SectionTitle icon={HelpSharpIcon}>
        <FormattedMessage id="app.report.manager.howToUse.title" />
      </SectionTitle>

      <Typography
        paragraph
        className={classes.divider}
      >
        <FormattedMessage id="app.report.manager.howToUse.description" />
      </Typography>

      <SectionTitle icon={EventAvailableSharpIcon}>
        <FormattedMessage id="app.report.manager.period.title" />
      </SectionTitle>

      <Typography paragraph>
        <FormattedMessage id="app.report.manager.period.description" />
      </Typography>

      <TipBox>
        <FormattedMessage id="app.report.manager.period.tip" />
      </TipBox>

      <TipBox>
        <FormattedMessage id="app.report.manager.period.warning" />
      </TipBox>

      <Divider className={classes.marginTop} />

      {/* indicadores/valores de comissões */}
      <SectionTitle icon={DragIndicatorSharpIcon}>
        <FormattedMessage id="app.report.manager.indicators.title" />
      </SectionTitle>

      <Typography paragraph>
        <strong>
          <FormattedMessage id="app.commission.type.BONUS" />
        </strong>
        {": "}
        <FormattedMessage id="app.commission.type.BONUS.description" />
      </Typography>

      <Typography paragraph>
        <strong>
          <FormattedMessage id="app.commission.type.BONUS_MANAGER_SPLIT" />
        </strong>
        {": "}
        <FormattedMessage id="app.commission.type.BONUS_MANAGER_SPLIT.description" />
      </Typography>

      <Typography paragraph>
        <strong>
          <FormattedMessage id="app.commission.type.BONUS_SPLIT" />
        </strong>
        {": "}
        <FormattedMessage id="app.report.manager.indicator.BONUS_SPLIT.description" />
      </Typography>

      <Typography paragraph>
        <strong>
          <FormattedMessage id="app.commission.type.BONUS_RECOMMENDANT" />
        </strong>
        {": "}
        <FormattedMessage id="app.report.manager.indicator.BONUS_RECOMMENDANT.description" />
      </Typography>

      {enableBonusManager && (
        <Typography paragraph>
          <strong>
            <FormattedMessage id="app.commission.type.BONUS_MANAGER" />
          </strong>
          {": "}
          <FormattedMessage id="app.report.manager.indicator.BONUS_MANAGER.description" />
        </Typography>
      )}

      {enableBonusManagerOneTime && (
        <Typography paragraph>
          <strong>
            <FormattedMessage id="app.commission.type.BONUS_LEADERSHIP_ONE_TIME" />
          </strong>
          {": "}
          <FormattedMessage id="app.report.manager.indicator.BONUS_LEADERSHIP_ONE_TIME.description" />
        </Typography>
      )}

      <TipBox>
        <FormattedMessage id="app.report.manager.indicators.note" />
      </TipBox>

      <TipBox>
        <FormattedMessage id="app.report.manager.indicators.remember" />
      </TipBox>

      <Divider className={classes.marginTop} />

      {/* resumo do período */}
      <SectionTitle icon={AssessmentIcon}>
        <FormattedMessage id="app.report.manager.summary.title" />
      </SectionTitle>

      <Typography
        paragraph
        className={classes.divider}
      >
        <FormattedMessage id="app.report.manager.summary.total" />
      </Typography>

      {/* tabela de pagamentos */}
      <SectionTitle icon={TableChartIcon}>
        <FormattedMessage id="app.report.manager.payments.title" />
      </SectionTitle>

      <Typography paragraph>
        <FormattedMessage id="app.report.manager.payments.description" />
      </Typography>

      <Typography paragraph>
        <strong>
          <FormattedMessage id="app.report.manager.important.label" />
        </strong>
        <FormattedMessage id="app.report.manager.payments.important" />
      </Typography>

      <Typography paragraph>
        <FormattedMessage id="app.report.manager.payments.tip.pagination" />
      </Typography>
      <TipBox>
        <FormattedMessage id="app.report.manager.payments.tip.sort" />
      </TipBox>
    </ActionDialog>
  );
};

export default HelpReportAgentsFinancial;
